export const getOktaToken = async (): Promise<string | undefined> => {
    if (typeof window !== 'undefined') {
        const Cookies = await import('js-cookie');
        return Cookies.default.get('oktaAccessToken');
    }

    try {
        const { cookies } = await import('next/headers');
        return (await cookies()).get('oktaAccessToken')?.value;
    } catch (err) {
        return undefined;
    }
};

export const normalizeHeaders = (headers: HeadersInit | undefined, token?: string): HeadersInit => {
    if (headers instanceof Headers) {
        const updated = new Headers(headers);
        if (token) updated.set('okta-token', token);
        return updated;
    }

    return {
        ...(headers || {}),
        ...(token ? { 'okta-token': token } : {}),
    };
};

export const injectOktaToken = async (init?: RequestInit): Promise<RequestInit> => {
    const token = await getOktaToken();

    return {
        ...init,
        headers: normalizeHeaders(init?.headers, token),
    };
};
